import { render, staticRenderFns } from "./student-dgt-report.component.vue?vue&type=template&id=106dc3cf&scoped=true"
import script from "./student-dgt-report.component.vue?vue&type=script&lang=js"
export * from "./student-dgt-report.component.vue?vue&type=script&lang=js"
import style0 from "./student-dgt-report.component.vue?vue&type=style&index=0&id=106dc3cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106dc3cf",
  null
  
)

export default component.exports